export default __webpack_public_path__ + "media/exports/required/assets/img/images/brand_white-81594c56baa54c548040f74f1fcd610d.png";